import React from 'react';
import Header from '../components/Header';
import History from '../assets/SVG/buttons/History-button.svg';
import useTitle from "../hooks/useTitle";
import '../styles/qripage.css';

export default function QRIpage(props) {
    useTitle("Instruction for Use");

    const handleClick = () => {
        props.location.state.covid ? 
            props.history.push({
                pathname: '/contraindications',
                state: { covid: true, isDemo: props?.location?.state?.isDemo }
            })
            : 
            props.history.push({
                pathname: '/beforetest',
                state: { covid: false, isDemo: props?.location?.state?.isDemo }
            })
    }

    return (
        <div className='container'>
            <div className='qri main'>
                <Header/>
                <p className='mt-3 heading'>Instruction for Use</p>
                <div className='wrapper mt-3'>
                    <p><span className='text-blue'>Step 1 - </span><span>Read the instructions carefully. 4 images will be taken automatically.</span></p>
                    <p><span className='text-blue'>Step 2 - </span><span>Choose an area where a bright light is filling your eyes area.</span></p>
                    <p><span className='text-blue'>Step 3 - </span><span>Unmute your phone and place it at eye level.</span></p>
                    <p><span className='text-blue'>Step 4 - </span><span>Allow the camera access for the test to start.</span></p>
                    <p><span className='text-blue'>Step 5 - </span><span>Move the camera closer until the line around your face turns green.</span></p>
                    <p><span className='text-blue'>Step 6 - </span><span>Look straight into the camera with eyes wide open until a selfie shot is taken.</span></p>
                    <p><span className='text-blue'>Step 7 - </span><span>Without moving your head, look to the right.</span></p>
                    <p><span className='text-blue'>Step 8 - </span><span>Without moving your head, look to the left.</span></p>
                    <p><span className='text-blue'>Step 9 - </span><span>Without moving your head, look up.</span></p>
                    <p><span className='text-blue'>Step 10 - </span><span>Test results appear after 30 seconds.</span></p>
                    <p><span className='text-blue'>Step 11 - </span><span>Answer Symptoms questionnaire.</span></p>
                    <p><span className='text-blue'>Step 12 - </span><span>Click the history button <img src={History} alt="history"/> on the home page for past results.</span></p>
                </div>
                {props.location.state ? 
                    <div className='mt-3 mb-5'>
                        <button id='ready' onClick={handleClick}>I am ready to do it</button>
                    </div>
                :<></>}
            </div>
        </div>
    )
}